const Oops = require('./Oops.js');
module.exports = Oops;